import { useNavigationHelper, useTargetBrandConfig } from 'FrontRoyalAngular';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

function OurTuitionModelBoxComponent() {
    const brandConfig = useTargetBrandConfig();
    const { loadUrl } = useNavigationHelper();
    const { t } = useTranslation('back_royal', { keyPrefix: 'ourTuitionModelBox' });

    const buttons = useMemo(
        () => [
            {
                id: 'button_learn_more',
                text: t('buttonLearnMore'),
                onPress: () => loadUrl(brandConfig.learnMoreAboutTuitionUrl, '_blank'),
            },
        ],
        [t, loadUrl, brandConfig],
    );
    return <OurTuitionModelBoxPresentation buttons={buttons} />;
}

function OurTuitionModelBoxPresentation({ buttons }: { buttons: ButtonConfig[] }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'ourTuitionModelBox' });
    return (
        <BasicDesktopBox headerText={t('heading')} buttons={buttons} boxKey={SidebarBoxKey.our_tuition_model}>
            {t('content')}
        </BasicDesktopBox>
    );
}

export const OurTuitionModelBox = memo(OurTuitionModelBoxComponent);
